/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable new-cap */

import { AsYouType, parse, format, getCountryCallingCode, isValidNumber } from 'libphonenumber-js';

const PhoneFormatter = {

  isValid(country, phone) {
    return isValidNumber({ phone, country });
  },

  format(country, number) {
    const asYouTypeFormatter = new AsYouType(country);
    return {
      number,
      formattedNumber: asYouTypeFormatter.input(number),
      isValid: PhoneFormatter.isValid(country, asYouTypeFormatter.national_number),
    };
  },

  formatTelephoneLink(country, phone) {
    const parsedNumber = country ? parse(phone, country) : { phone };
    return format(parsedNumber, 'RFC3966');
  },

  getCountryCallingCode(country) {
    return country ? getCountryCallingCode(country) : '';
  },

};

export default PhoneFormatter;
